import { baseModule } from '@/container-modules/base-module';
import { headerServiceModule } from '@/container-modules/header-service-module';
import { chatContainer } from '@/domains/chat/index';
import { Container } from '@patsnap/tahiti-core/shared/inversify';
import { sharedContainer } from '@/domains/shared';
import { biTrackModule } from '@eureka/domains';
import { trizContainer } from '@/domains/triz/index'
import { authModule } from '@eureka/shared/share-tools/src/domain/auth-module';

const container = new Container({
    defaultScope: 'Singleton',
    skipBaseClassChecks: true,
});

container.load(
    baseModule,
    headerServiceModule,
    chatContainer,
    sharedContainer,
    biTrackModule,
    trizContainer,
    authModule
);

export {
    container,
};
